// AI Generated File
import { Injectable } from '@angular/core';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Injectable({
    providedIn: 'root',
})
export class HeatmapService {

    constructor (
        private monModalService: MonModalService,
        private translateService: TranslateService,
    ) {}

    confirmDelete (rule: any): Promise<string> {
        const translateParams = {
            pageUrl: rule.page ? rule.page.url : this.translateService.getString('(No title found)'),
        };

        const message = this.translateService.getString(
            'Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>',
            translateParams,
        );

        return this.monModalService.confirm(message);
    }
}
